import { useState, useEffect } from 'react';
import ToggleButton from '@mui/material/ToggleButton';
import ToggleButtonGroup from '@mui/material/ToggleButtonGroup';

export default function ButtonGroupDificultad({
  value,
  onChange,
  modo,
  accentColor = '#6366f1',
  accentHoverColor = '#4f46e5',
}) {
  const MIXED_VALUE = 'mixed';
  const [alignment, setAlignment] = useState(value ?? MIXED_VALUE);

  useEffect(() => {
    setAlignment(value ?? MIXED_VALUE);
  }, [value]);

  useEffect(() => {
    if (modo === 'enarm') {
      setAlignment(MIXED_VALUE);
      onChange(null);
    }
  }, [modo, onChange]);

  const handleChange = (event, newAlignment) => {
    setAlignment(newAlignment);
    onChange(newAlignment === MIXED_VALUE ? null : newAlignment);
  };

  const buttonSx = {
    flex: 1,
    minWidth: 0,
    fontWeight: 500,
    whiteSpace: 'nowrap',
    borderColor: 'transparent',
    '&:focus': {
      outline: 'none',
    },
    '&:focus-visible': {
      outline: 'none',
    },
    px: { xs: 1, sm: 1.5 },
    py: { xs: 0.75, sm: 1 },
    fontSize: { xs: '0.75rem', sm: '0.875rem' },
    '&.Mui-selected': {
      backgroundColor: accentColor,
      color: 'secondary.contrastText',
      boxShadow: 'none',
      borderColor: 'transparent',
    },
    '&.Mui-selected:hover': {
      backgroundColor: accentHoverColor,
      color: 'secondary.contrastText',
      borderColor: 'transparent',
    },
  };

  return (
    <>
    <h3 className="text-sm font-semibold mb-2">Dificultad</h3>
    <ToggleButtonGroup
      color="secondary"
      value={alignment}
      exclusive
      onChange={handleChange}
      aria-label="Dificultad"
      sx={{
        width: '100%',
        flexWrap: 'wrap',
        border: '1px solid #cbd5e1',
        borderRadius: '10px',
        overflow: 'hidden',
        '& .MuiToggleButtonGroup-grouped': {
          margin: 0,
          border: 0,
          borderRadius: 0,
        },
        '& .MuiToggleButtonGroup-grouped:not(:last-of-type)': {
          borderRight: '1px solid #e2e8f0',
        },
      }}
      disabled={modo === 'enarm'}
    >
      <ToggleButton value={MIXED_VALUE} sx={buttonSx} disabled={modo === 'enarm'}>
        Mixta
      </ToggleButton>
      <ToggleButton value={"easy"} sx={buttonSx} disabled={modo === 'enarm'}>
        Básica
      </ToggleButton>
      <ToggleButton value={"medium"} sx={buttonSx} disabled={modo === 'enarm'}>
        Media
      </ToggleButton>
      <ToggleButton value={"hard"} sx={buttonSx} disabled={modo === 'enarm'}>
        Alta
      </ToggleButton>
    </ToggleButtonGroup>
    </>
  );
}